import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Opts } from "@ofqual/portal-core/core/types";
import { AdditionalEvidenceRequest } from "../domain/AdditionalEvidenceRequest";

export class ExpansionApplicationEvidenceRequestService extends BaseRemoteService {

  public async get(orgId: string, id: string, requestId: string, opts: Opts): Promise<AdditionalEvidenceRequest> {
    const url = `${this.apiRoot}/api/organisations/${orgId}/expansionapplications/${id}/additionalevidence/${requestId}`;
    try {
      return await super.getRequest<AdditionalEvidenceRequest>(url, opts);
    } catch (err) {
      throw err;
    }
  }

  public async update(
    orgId: string,
    id: string,
    requestId: string,
    evidence: AdditionalEvidenceRequest,
    opts: Opts
  ) {
    const url = `${this.apiRoot}/api/organisations/${orgId}/expansionapplications/${id}/additionalevidence/${requestId}`;
    return await super.putRequest(
      url,
      evidence,
      opts
    );
  }

  public async updateOtherEvidence(
    orgId: string,
    id: string,
    requestId: string, 
    files: File[], 
    evidence: AdditionalEvidenceRequest,
    opts: Opts
  ) { 
    const body = JSON.stringify(evidence); 
    const url = `${this.apiRoot}/api/organisations/${orgId}/expansionapplications/${id}/additionalevidence/${requestId}/otherevidence`;
    return await super.putRequestFormData(
      url,
      {files, body},
      opts
    );
  }

  public async downloadAttachment(
    orgId: string,
    id: string,
    requestId: string,
    blobId: string,
    opts: Opts
  ) {
    const url = `${this.apiRoot}/api/organisations/${orgId}/expansionapplications/${id}/additionalevidence/${requestId}/attachments/${blobId}`;
    return await super.getRequestBlob(url, opts);
  }


  public async submit(
    orgId: string,
    id: string,
    requestId: string,
    timestamp: string,
    opts: Opts
  ) {
    const url = `${this.apiRoot}/api/organisations/${orgId}/expansionapplications/${id}/additionalevidence/${requestId}/submit`;
    return await super.putRequest(
      url,
      {timestamp},
      opts
    );
  }
}